module.exports = __webpack_public_path__ + "static/media/icon-bedroom-5.0587b9bc.svg";